import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { useFlags } from 'launchdarkly-react-client-sdk'
import { Box, useTheme, useMediaQuery } from '@mui/material'
import { get } from 'utils/lodash'
import { isLateFeeFeatureAvailable } from 'data/launch-darkly/featureSelectors'
import { CUSTOMER_DETAILS_TABS_ID } from 'containers/customer-details/settings'

import TabMainLayout from 'components/customer-details/layout/TabMainLayout'
import LateFeesAccordion from 'components/customer-details/content/fees/late_fees/LateFeesAccordion'
import RentalFeesAccordion from '../content/fees/rental-fees/RentalFeesAccordion'
import { LAYOUT_HEIGHT } from '../layout/settings'

const { FEES_TAB_ID } = CUSTOMER_DETAILS_TABS_ID
const SHOW_RENTAL_FEES_SECTION = false

const FeesTab = ({ selectedTab = '', customerDetails = {} }) => {
  const theme = useTheme()
  const flags = useFlags()
  const isLateFeeEnabled = isLateFeeFeatureAvailable({ flags })
  const isTabletorMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const accountId = get(customerDetails, 'id')
  const [isFeesTabReady, setIsFeesTabReady] = useState(false)

  useEffect(() => {
    if (selectedTab === FEES_TAB_ID) {
      setIsFeesTabReady(true)
    }
  }, [selectedTab])

  return (
    isFeesTabReady && (
      <TabMainLayout>
        <Box px={4} pt={1} pb={3} flex={1} height={isTabletorMobile ? '100%' : LAYOUT_HEIGHT} overflow="auto">
          {isLateFeeEnabled && (
            <Box mt={2}>
              <LateFeesAccordion customerDetails={customerDetails} />
            </Box>
          )}
          {SHOW_RENTAL_FEES_SECTION && (
            <Box mt={2}>
              <RentalFeesAccordion accountId={accountId} />
            </Box>
          )}
        </Box>
      </TabMainLayout>
    )
  )
}

FeesTab.propTypes = {
  selectedTab: PropTypes.string,
  customerDetails: PropTypes.object,
}

export default FeesTab
